import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import styles from "./Pagination.module.scss";

const TOTAL_PAGENATION_BLOCK_NUM = 5;

export interface PaginationProps {
  total: number;
  page: number;
  onClick: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  total,
  page,
  onClick,
}) => {
  if (total <= 1) {
    return null;
  }
  let pages = Array.from(new Array(total)).map((v, idx) => idx + 1);
  if (pages.length > TOTAL_PAGENATION_BLOCK_NUM) {
    if (page > 2) {
      if (page > total - 3) {
        pages = [1, 0, total - 3, total - 2, total - 1, total];
      } else if (page === 3) {
        pages = [1, page - 1, page, page + 1, 0, total];
      } else {
        pages = [1, 0, page - 1, page, page + 1, 0, total];
      }
    } else {
      pages = [1, 2, 3, 0, total];
    }
  }
  return (
    <div className={styles.pagination}>
      <div
        className={`${page === 1 ? styles.invalidLink : styles.validLink}`}
        onClick={() => onClick(page - 1)}
      >
        <LeftOutlined className={styles.leftIcon} />
      </div>
      {pages.map((n, idx) => {
        return n === 0 ? (
          // eslint-disable-next-line
          <div key={idx} className={styles.threeDots}>
            …
          </div>
        ) : (
          <div
            // eslint-disable-next-line
            key={idx}
            className={`${styles.validLink} ${page === n ? styles.active : ""}`}
            onClick={() => onClick(n)}
          >
            {n}
          </div>
        );
      })}
      <div
        className={`${page === total ? styles.invalidLink : styles.validLink}`}
        onClick={() => onClick(page + 1)}
      >
        <RightOutlined className={styles.rightIcon} />
      </div>
    </div>
  );
};

export default Pagination;
